import { createFileRoute } from '@tanstack/react-router';
import { ProfileContent } from '@/features/shared/profile';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/profile')({
  beforeLoad: clientGuard,
  component: () => <ProfileContent />,
});
